import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Santacruztopunecabs() {



  const cardData = {


   keyword: "Santacruz to Pune Cabs",

  headingDescription: "Trustline Cab provides reliable Santacruz to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth highway travel, and a comfortable journey from Santacruz to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to meet every passenger requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Santacruz to Pune taxi services.",

  topPlaces: [
    {
      title: "Wakad",
      description: "Wakad is a rapidly growing suburb of Pune known for residential developments, commercial complexes, restaurants, and excellent connectivity to Hinjewadi IT Park. It is a preferred destination for IT professionals and business travelers."
    },
    {
      title: "Baner",
      description: "Baner is a premium commercial and residential locality featuring IT offices, business centers, restaurants, educational institutions, and modern housing projects. It attracts professionals, families, and corporate visitors."
    },
    {
      title: "Balewadi High Street",
      description: "Balewadi High Street is a popular commercial and lifestyle destination in Pune, offering restaurants, cafés, retail outlets, business spaces, and entertainment options. It is frequently visited by professionals and tourists."
    },
    {
      title: "Chakan Industrial Area",
      description: "Chakan Industrial Area is a major manufacturing and logistics hub housing automobile companies, engineering industries, warehouses, and large corporate units. It is an important destination for industrial travel."
    },
    {
      title: "Akurdi",
      description: "Akurdi is an important educational and commercial locality in Pune, known for engineering institutes, corporate offices, residential areas, and convenient access to Pimpri Chinchwad industrial zones."
    },
    {
      title: "Kharadi",
      description: "Kharadi is one of Pune's leading IT and business destinations, home to EON IT Park, multinational companies, corporate offices, and modern commercial infrastructure. It attracts business travelers throughout the year."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is a famous historical monument in Pune known for its Maratha heritage, grand architecture, and cultural importance. It is one of the city's most visited tourist attractions."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description: "Dagdusheth Halwai Ganpati Temple is one of Pune's most famous religious landmarks, attracting thousands of devotees and visitors every year due to its cultural importance and spiritual significance."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a beautiful hill station located between Mumbai and Pune, famous for waterfalls, green valleys, viewpoints, caves, and pleasant weather. It is a popular weekend destination for travelers."
    },
    {
      title: "Karla Caves",
      description: "Karla Caves are ancient Buddhist rock-cut caves near Lonavala featuring historic architecture, impressive carvings, and cultural significance. They are a popular sightseeing attraction for visitors traveling between Mumbai and Pune."
    }
  ],






"services": [
  {
    "name": "Santacruz to Pune Taxi Fare",
    "description": "Check Santacruz to Pune Taxi Fare with affordable pricing, transparent charges, multiple vehicle options, and comfortable chauffeur-driven travel. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cars for business trips, family journeys, airport transfers, and outstation travel."
  },
  {
    "name": "Santacruz Airport to Pune Taxi Fare",
    "description": "Get Santacruz Airport to Pune Taxi Fare with reliable airport transfer service, fixed pricing, professional drivers, clean AC vehicles, luggage assistance, and timely pickup for a smooth journey."
  },
  {
    "name": "Santacruz Airport to Pune One Way Taxi",
    "description": "Book Santacruz Airport to Pune One Way Taxi for direct airport travel with no return charges, comfortable cars, experienced chauffeurs, and affordable one-way fares."
  },
  {
    "name": "Mumbai to Pune Cab Booking",
    "description": "Complete Mumbai to Pune Cab Booking online with instant confirmation, premium vehicle choices, professional chauffeurs, transparent pricing, and reliable intercity transportation."
  },
  {
    "name": "Santacruz Airport to Pune Taxi Service",
    "description": "Choose Santacruz Airport to Pune Taxi Service for safe airport transfers with AC vehicles, trained drivers, doorstep pickup, flexible booking, and comfortable travel."
  },
  {
    "name": "Santacruz to Pune by Taxi",
    "description": "Travel from Santacruz to Pune by Taxi with clean vehicles, experienced chauffeurs, affordable fares, spacious seating, and reliable highway connectivity."
  },
  {
    "name": "Santacruz to Pune Innova Crysta",
    "description": "Book Santacruz to Pune Innova Crysta for premium family and corporate travel with luxury interiors, spacious seating, AC comfort, and professional driver service."
  },
  {
    "name": "Santacruz to Pune Ertiga Taxi",
    "description": "Choose Santacruz to Pune Ertiga Taxi for comfortable group travel with affordable fares, spacious seating, luggage space, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Santacruz to Pune Sedan Taxi",
    "description": "Book Santacruz to Pune Sedan Taxi for economical and comfortable travel with professional drivers, clean AC cars, transparent pricing, and smooth journeys."
  },
  {
    "name": "Mumbai International Airport to Pune Cab",
    "description": "Reserve Mumbai International Airport to Pune Cab for airport pickup and drop service with premium vehicles, punctual drivers, luggage support, and affordable rates."
  },
  {
    "name": "Cab Service in Santacruz West",
    "description": "Get Cab Service in Santacruz West for local and outstation travel with professional chauffeurs, clean vehicles, airport transfers, and reliable booking support."
  },
  {
    "name": "Best Cab Service in Santacruz",
    "description": "Choose Best Cab Service in Santacruz for affordable travel solutions with premium cars, experienced drivers, quick booking, and dependable transportation."
  },
  {
    "name": "Santacruz Airport Cab Service",
    "description": "Book Santacruz Airport Cab Service for convenient airport transfers with AC cars, trained chauffeurs, timely pickup, and comfortable travel experience."
  },
  {
    "name": "Santa Cruz Airport Car Service",
    "description": "Choose Santa Cruz Airport Car Service for reliable airport transportation with premium vehicles, professional drivers, and flexible travel options."
  },
  {
    "name": "Innova Crysta on Rent in Santacruz",
    "description": "Hire Innova Crysta on Rent in Santacruz for family trips, corporate travel, airport transfers, and private journeys with luxury comfort and professional chauffeurs."
  },
  {
    "name": "Ertiga on Rent in Santacruz",
    "description": "Book Ertiga on Rent in Santacruz for spacious and affordable travel with comfortable seating, clean vehicles, and experienced drivers."
  },
  {
    "name": "Taxi Service in Santacruz",
    "description": "Choose Taxi Service in Santacruz for reliable local and outstation transportation with affordable fares, premium vehicles, and 24x7 customer support."
  },
  {
    "name": "Cab Service in Mumbai City",
    "description": "Get Cab Service in Mumbai City for airport transfers, corporate travel, family trips, and outstation journeys with professional chauffeurs and quality vehicles."
  },
  {
    "name": "Santacruz to Pune Cab",
    "description": "Book Santacruz to Pune Cab for one-way, round-trip, airport, and outstation travel with Sedan, Ertiga, Innova Crysta, SUV, and premium car options."
  },
  {
    "name": "Santacruz to Pune Taxi",
    "description": "Choose Santacruz to Pune Taxi for comfortable intercity travel with experienced drivers, clean AC vehicles, transparent pricing, and reliable service."
  },
  {
    "name": "Santacruz to Pune Cab Service",
    "description": "Reserve Santacruz to Pune Cab Service with professional chauffeurs, doorstep pickup, affordable fares, premium vehicles, and safe highway travel."
  },
  {
    "name": "Santacruz to Pune Taxi Service",
    "description": "Book Santacruz to Pune Taxi Service for smooth transportation with experienced drivers, flexible schedules, AC cars, and customer-friendly support."
  },
  {
    "name": "Santacruz to Pune Cab Booking",
    "description": "Complete Santacruz to Pune Cab Booking with quick confirmation, multiple vehicle choices, transparent fares, and hassle-free reservation."
  },
  {
    "name": "Cab from Santacruz to Pune",
    "description": "Hire Cab from Santacruz to Pune with chauffeur-driven vehicles, comfortable seating, luggage space, and reliable long-distance travel service."
  },
  {
    "name": "Santacruz to Pune Car Rental",
    "description": "Choose Santacruz to Pune Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for business and personal travel."
  },
  {
    "name": "Santacruz to Pune One Way Cab",
    "description": "Book Santacruz to Pune One Way Cab for affordable direct travel with fixed fares, professional drivers, and comfortable AC vehicles."
  },
  {
    "name": "Cheap Santacruz to Pune Cab",
    "description": "Choose Cheap Santacruz to Pune Cab with budget-friendly fares, clean vehicles, experienced chauffeurs, and dependable service."
  },
  {
    "name": "Book Santacruz to Pune Cab Online",
    "description": "Book Santacruz to Pune Cab Online with instant confirmation, secure booking, flexible timings, and professional chauffeur assistance."
  },
  {
    "name": "Santacruz to Pune Outstation Cab",
    "description": "Travel with Santacruz to Pune Outstation Cab featuring safe highway travel, premium cars, trained drivers, and affordable packages."
  },
  {
    "name": "Santacruz to Pune Airport Cab",
    "description": "Reserve Santacruz to Pune Airport Cab for airport transfers with punctual pickup, luggage support, comfortable AC vehicles, and reliable service."
  },
  {
    "name": "24x7 Santacruz to Pune Taxi Service",
    "description": "Get 24x7 Santacruz to Pune Taxi Service with round-the-clock booking support, professional chauffeurs, and comfortable travel solutions."
  },
  {
    "name": "Best Santacruz to Pune Cab Service",
    "description": "Choose Best Santacruz to Pune Cab Service for premium vehicles, affordable pricing, experienced drivers, and reliable Mumbai Pune transportation."
  }
],

"tableData": [
  ["Santacruz to Pune Taxi Fare", "Santacruz Airport to Pune Taxi Fare"],
  ["Santacruz Airport to Pune One Way Taxi", "Mumbai to Pune Cab Booking"],
  ["Santacruz Airport to Pune Taxi Service", "Santacruz to Pune by Taxi"],
  ["Santacruz to Pune Innova Crysta", "Santacruz to Pune Ertiga Taxi"],
  ["Santacruz to Pune Sedan Taxi", "Mumbai International Airport to Pune Cab"],
  ["Cab Service in Santacruz West", "Best Cab Service in Santacruz"],
  ["Santacruz Airport Cab Service", "Innova Crysta on Rent in Santacruz"],
  ["Ertiga on Rent in Santacruz", "Taxi Service in Santacruz"],
  ["Cab Service in Mumbai City", "Santacruz to Pune Cab"],
  ["Santacruz to Pune Taxi", "Santacruz to Pune Cab Service"],
  ["Santacruz to Pune Taxi Service", "Santacruz to Pune Cab Booking"],
  ["Cab from Santacruz to Pune", "Santacruz to Pune Car Rental"],
  ["Santacruz to Pune One Way Cab", "Cheap Santacruz to Pune Cab"],
  ["Book Santacruz to Pune Cab Online", "Santacruz to Pune Outstation Cab"],
  ["Santacruz to Pune Airport Cab", "24x7 Santacruz to Pune Taxi Service"],
  ["Best Santacruz to Pune Cab Service", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Santacruz to Pune Cab Service",
    WhyChoosedescription: "Trustline Travels offers comfortable Santacruz to Pune cab services with experienced drivers, quality vehicles, and dependable travel solutions for every passenger."
  },
  {
    WhyChooseheading: "Easy Pickup from Santacruz",
    WhyChoosedescription: "Enjoy convenient pickup from Santacruz East, Santacruz West, hotels, offices, residential areas, and nearby locations with direct drop in Pune."
  },
  {
    WhyChooseheading: "Smooth Mumbai Pune Route Travel",
    WhyChoosedescription: "Our professional chauffeurs ensure a safe and comfortable journey with proper route planning through the Mumbai-Pune Expressway."
  },
  {
    WhyChooseheading: "Multiple Vehicle Choices Available",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your group size and comfort preference."
  },
  {
    WhyChooseheading: "Transparent & Affordable Cab Fare",
    WhyChoosedescription: "Get competitive Santacruz to Pune cab rates with clear pricing details and no hidden charges before confirming your trip."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Trips",
    WhyChoosedescription: "Book one-way cabs, round trips, or customized travel plans according to your schedule and travel requirements."
  },
  {
    WhyChooseheading: "Perfect for Airport & Business Travel",
    WhyChoosedescription: "Our Santacruz to Pune cabs are suitable for Mumbai Airport transfers, corporate meetings, family travel, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Get quick booking assistance and round-the-clock travel support whenever you need a cab from Santacruz to Pune."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Santacruz to Pune cab service?",
    answer: "Yes, Trustline Cab provides reliable Santacruz to Pune cab services for one-way travel, round trips, airport transfers, and corporate journeys."
  },
  {
    question: "Can I book a one-way cab from Santacruz to Pune?",
    answer: "Yes, one-way cab booking is available from Santacruz to Pune with flexible pickup and drop options."
  },
  {
    question: "Do you provide pickup from Santacruz East and Santacruz West?",
    answer: "Yes, pickup service is available from both Santacruz East and Santacruz West along with nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Santacruz to Pune travel?",
    answer: "We offer Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to passenger requirements."
  },
  {
    question: "Can I book a Santacruz to Pune cab from Mumbai Airport area?",
    answer: "Yes, we provide convenient airport pickup services from Mumbai Airport and nearby Santacruz locations to Pune."
  },
  {
    question: "Is Santacruz to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 for early morning, daytime, and late-night travel."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless mentioned in your booking quotation."
  },
  {
    question: "Can I schedule my Santacruz to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to confirm your preferred vehicle and pickup timing."
  },
  {
    question: "Do you provide Santacruz to Pune cabs for office travel?",
    answer: "Yes, our cab services are suitable for corporate employees, business meetings, and professional travel requirements."
  },
  {
    question: "How can I book Santacruz to Pune Cabs with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to get an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Shetty",
    feedback: "Trustline Travels provided an excellent Santacruz to Pune journey with timely pickup, a comfortable cab, and professional driver service. The complete trip was smooth and well-managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback: "The booking process was simple and the travel experience was very comfortable. The clean vehicle, polite driver, and punctual service made the journey enjoyable.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Santacruz to Pune Cabs Service",
  "image": "https://www.trustlinetravels.com/assets/images/santacruz-to-pune-cabs.webp",
  "description": "Book Santacruz to Pune cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport, and outstation taxi services from Santacruz Mumbai to Pune with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7916"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/santacruz-to-pune-cabs"
  }
};




  return (
    <div>

<Helmet>
  <title>Santacruz to Pune Cabs | Airport Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Santacruz to Pune cab service with Trustline Travels for reliable and comfortable travel. Get one-way, round-trip, airport, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="santacruz to pune taxi fare, santacruz airport to pune taxi fare, santacruz airport to pune one way taxi, mumbai to pune cab booking, santacruz airport to pune taxi service, santacruz to pune by taxi, santacruz to pune innova crysta, santacruz to pune cab, Santacruz to Pune Cabs, Santacruz Airport to Pune Taxi, Santacruz Pune One Way Cab, Santacruz Pune Outstation Taxi, Santacruz Pune Airport Transfer"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Santacruztopunecabs;